window.whitespaceFormatter = function(value, row) {
    let html = '';
    html += '<div style="white-space: normal !important">';
    html += value;
    html += '</div>';
    return html;
};
